////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { find, isNull } from 'lodash'
import { shallowEqual, useSelector } from 'react-redux'
///////COMPONENTS///////
import StringFormatter from '../../../../helpers/StringFormatter'
import PriceFormatter from '../../../../helpers/PriceFormatter'
/////////ASSETS/////////
import InfoAlert from '../../../../assets/icones/global/info-big-blue.svg'
import ErrorAlert from '../../../../assets/icones/global/warning-red.svg'

//////STYLED//////
const BodyCells = styled.td`
	display: table-cell;
	text-align: center;
	background-color: inherit;
	height: 50px;
	box-sizing: border-box;
	padding: 5px 5px;
	border-top: 1px solid ${(props) => props.theme.colors.table.borderTable};
`
const BodyCellsRightBorder = styled(BodyCells)`
	border-right: 1px solid ${(props) => props.theme.colors.table.borderTable};
`
const ColorSpan = styled.span`
	color: #0885d5;
`
const ErrorFormCampaign = styled.div`
	display: flex;
	justify-content: center;
	align-content: center;
	background-color: ${(props) => props.theme.colors.errorlight};
	padding: 10px;
	border-radius: 5px;
`
const InfoFormCampaign = styled.div`
	display: flex;
	justify-content: center;
	align-content: center;
	background-color: ${(props) => props.theme.colors.info};
	padding: 10px;
	border-radius: 5px;
	color: ${(props) => props.theme.colors.primary};
`
const LineInfoImg = styled.img`
	max-height: 20px;
	margin-right: 10px;
`
//////STYLED//////

const PriceCampaignUpdateSecondLine = (props) => {
	const currency = props.column[0].currency || '$'
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	const errorsCalls = find(props.column[0].callErrors, { id: props.row.lineNumber }) || false

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<>
			<BodyCellsRightBorder>
				<ColorSpan>{translations['modal__pricesManagement__pricesCampaign_creation_newValues']}</ColorSpan>{' '}
			</BodyCellsRightBorder>
			<BodyCells colSpan="5">
				{errorsCalls ? (
					<ErrorFormCampaign>
						<LineInfoImg src={ErrorAlert} />
						{errorsCalls && (
							<span>{StringFormatter.ResponseMessageParser(translations[errorsCalls.traductionKey], errorsCalls.msgParameters)}</span>
						)}
					</ErrorFormCampaign>
				) : (
					<InfoFormCampaign>
						<LineInfoImg src={!errorsCalls ? '' : InfoAlert} />
						<span>{translations['page__promotionManagement__update_table_newValues_message']}</span>
					</InfoFormCampaign>
				)}
			</BodyCells>
			<BodyCells>{`${props.row.standardPrice}${currency}`}</BodyCells>
			<BodyCells>{`${PriceFormatter.vatConverter(false, props.row.standardPrice, props.row.standardPriceVATRate)}${currency}`}</BodyCells>
			<BodyCells>{`${props.row.standardPriceVATRate}%`}</BodyCells>
			<BodyCells>{isNull(props.row.depositPrice) ? `0,00${currency}` : `${props.row.depositPrice}${currency}`}</BodyCells>
			<BodyCells>{`${props.row.depositPriceVATRate}%`}</BodyCells>
		</>
	)
}

PriceCampaignUpdateSecondLine.propTypes = {}

PriceCampaignUpdateSecondLine.defaultPropTypes = {}

export default PriceCampaignUpdateSecondLine
